import { render, staticRenderFns } from "./RateTypeCancellationPolicy.vue?vue&type=template&id=b7f6a724&"
import script from "./RateTypeCancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./RateTypeCancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f6a724')) {
      api.createRecord('b7f6a724', component.options)
    } else {
      api.reload('b7f6a724', component.options)
    }
    module.hot.accept("./RateTypeCancellationPolicy.vue?vue&type=template&id=b7f6a724&", function () {
      api.rerender('b7f6a724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RateTypeCancellationPolicy.vue"
export default component.exports